import { ITagDataWithCreateIcon } from '../../../module/private-template-module-tag/api/types';

export interface ITagGroup {
	id: string;
	name: string;
	tags: ITagDataWithCreateIcon[];
}

export enum TagGroupType {
	tagsWithoutGroup = 'tagsWithoutGroup',
	createGroup = 'createGroup',
}
